<div class="seller-info-cntr">

    <div class="img-cntr">
        <img [src]="configuration.avatar">
    </div>

    <div class="txt-cntr">
        <h4>{{configuration.seller}}</h4>
        <p>Venditore</p>
    </div>

</div>
